import { Fragment, NODE_MISSING_FRAGMENT, Schema } from '@gitbook/slate';
import { isUrl } from '@gitbook/util-url';

import { createParagraph } from '../paragraph';
import { BLOCK_EMBED, BLOCK_PARAGRAPH, FRAGMENT_CAPTION } from '../types';

/**
 * Schema to validate embeds.
 */
export const schema = Schema.create({
    blocks: {
        [BLOCK_EMBED]: {
            parent: { objects: ['document', 'block'] },
            isVoid: true,
            data: {
                url: (url) => isUrl(url),
                fullWidth: (fullWidth) =>
                    typeof fullWidth === 'undefined' || typeof fullWidth === 'boolean',
            },
            fragments: {
                keys: [FRAGMENT_CAPTION],
                nodes: [{ types: [BLOCK_PARAGRAPH], min: 1, max: 1 }],
            },
            normalize: (change, violation, { node }) => {
                switch (violation) {
                    case NODE_MISSING_FRAGMENT: {
                        return change.setFragmentByKey(
                            // @ts-expect-error
                            node.key,
                            Fragment.create({
                                fragment: FRAGMENT_CAPTION,
                                nodes: [createParagraph()],
                            })
                        );
                    }
                }
            },
        },
    },
});
